import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { WeddingsPage } from './pages/WeddingsPage';
import { BirthdaysPage } from './pages/BirthdaysPage';
import { SpecialEventsPage } from './pages/SpecialEventsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/weddings" element={<WeddingsPage data-id="element-6" />} data-id="element-5" />
          <Route path="/birthdays" element={<BirthdaysPage data-id="element-8" />} data-id="element-7" />
          <Route path="/special-events" element={<SpecialEventsPage data-id="element-10" />} data-id="element-9" />
          <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}